@if (visible) {
    <form #stepForm="ngForm" class="form-page">
        <input type="text" name="tenantName" required hidden #tenantName="ngModel" [(ngModel)]="form.tenantName" />
        <label [class.hidden]="state === stateEnum.SUCCESS">
            <span>{{ 'form.token' | translate }}</span>
            <input
                id="token-input"
                type="text"
                name="token"
                required
                #token="ngModel"
                [placeholder]="'form.token' | translate"
                [(ngModel)]="form.token"
                [disabled]="state >= stateEnum.LOADED"
                [minlength]="tokenValidation.length"
                [maxlength]="tokenValidation.length"
                [pattern]="tokenValidation.pattern"
                (paste)="onTokenPaste($event)"
                (keyup)="onTokenInput()"
            />
        </label>
        @if (state !== stateEnum.START && loadedInvitation.tenantName) {
            <div class="title-start">
                <strong>{{ 'steps.tenant-invite.start' | translate: loadedInvitation }}</strong>
                <p [innerHTML]="'steps.tenant-invite.start_subtitle' | translate: loadedInvitation"></p>
            </div>
        }
        @if (state === stateEnum.ERROR) {
            <div class="form-error">
                @for (errorCode of inviteErrorCodes; track errorCode) {
                    @if (tenantName.errors?.[errorCode]) {
                        <div>
                            {{
                                'validation.inviteErrorReason'
                                    | translate: { reason: 'validation.reasons.' + errorCode | translate }
                            }}
                        </div>
                    }
                }
                @if (tenantName.errors?.inviteError) {
                    <div>{{ 'validation.invite.inviteError' | translate }}</div>
                }
                @if (token.errors?.invalidToken || invalidToken) {
                    <div>{{ 'validation.invalidToken' | translate }}</div>
                }
                @if (token.errors?.expiredToken) {
                    <div>{{ 'validation.expiredToken' | translate }}</div>
                }
                @if (maxLengthExceeded || token.errors?.maxLength) {
                    <div>
                        {{ 'validation.exceededMaxLengthToken' | translate }}
                    </div>
                }
            </div>
        }
    </form>
}
